import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[tpiAlphanumericSpacesDirective]'

})
export class AlphanumericSpacesDirective {
    private element = inject(ElementRef);
    private ngControl = inject(NgControl);

    @HostListener('input', ['$event']) onInputChange(event): void {
        const initalValue = this.element.nativeElement.value;
        const initalValueReplace = initalValue.replace(/[^a-zA-Z0-9\s]*/g, '');
        this.element.nativeElement.value = initalValueReplace;
        this.ngControl.control.setValue(initalValueReplace);
        if (initalValue !== this.element.nativeElement.value) {
            event.stopPropagation();
        }
    }
}